module.exports = require("core-js/modules/es.weak-map.js");